export function downloadImage(src: string) {
  const image = new Image()
  image.src = src
  image.onload = () => {}
  return image
}
